module.exports = "<div></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/u-grid/index.html
// module id = 442
// module chunks = 144